(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const trigger = document.querySelector('#etrusted-product_star');
    if (!trigger) return;
    trigger.addEventListener('click', function () {
      const reviewsTabButton = document.querySelector('[data-title="Reviews"]');
      if (!reviewsTabButton) return;

      document.querySelector('[data-title="Reviews"] input').click();

      setTimeout(() => {
        const reviewsContent = document.querySelector(
          '#reviews, .reviews, [data-title="Reviews"]'
        );

        if (reviewsContent) {
          reviewsContent.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      }, 200);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-sticky-information"] && !Shopify.designMode) return;
  try {
    
  const stickyBar = document.querySelector('.product-sticky-information');
  const buyButtonsBlock = document.querySelector('.buy-buttons-block .product-form-buttons');

  if (stickyBar && buyButtonsBlock) {
    window.addEventListener('scroll', function () {
      const scrollY = window.scrollY || window.pageYOffset;
      const triggerPoint = buyButtonsBlock.getBoundingClientRect().bottom + window.scrollY;

      if (scrollY > triggerPoint) {
        stickyBar.classList.add('show');
      } else {
        stickyBar.classList.remove('show');
      }
    });
  }

  const stickySelect = document.getElementById('sticky-variant-select');
  const radioInputs = document.querySelectorAll('.sticky-variant-radio input');
  const mainVariantPicker = document.querySelector('variant-picker[ref="mainVariantPicker"]');
  const hiddenInputs = stickyBar
    ? stickyBar.querySelectorAll('input[ref="variantId"]')
    : [];

  // helper sync
  function syncVariant(variantId) {
    hiddenInputs.forEach(input => {
      input.value = variantId;
    });

    const radioInput = mainVariantPicker?.querySelector(
      `input[data-variant-id="${variantId}"]`
    );

    if (radioInput) {
      radioInput.checked = true;
      radioInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  // SELECT -> radios + main
  if (stickySelect) {
    stickySelect.addEventListener('change', function () {
      const variantId = this.value;

      radioInputs.forEach(r => {
        r.checked = r.value === variantId;
      });

      syncVariant(variantId);
    });
  }

  // RADIOS -> select + main
  radioInputs.forEach(radio => {
    radio.addEventListener('change', function () {
      const variantId = this.value;

      if (stickySelect) {
        stickySelect.value = variantId;
      }

      syncVariant(variantId);
    });
  });

  if (mainVariantPicker) {
    const allVariantInputs = mainVariantPicker.querySelectorAll(
      'input[type="radio"][data-variant-id]'
    );

    allVariantInputs.forEach(input => {
      input.addEventListener('change', function () {
        const variantId = this.dataset.variantId;

        if (stickySelect) {
          stickySelect.value = variantId;
        }

        radioInputs.forEach(r => {
          r.checked = r.value === variantId;
        });
      });
    });
  }

  } catch(e) { console.error(e); }
})();
})();
